export var PersistenceMode;
(function (PersistenceMode) {
    PersistenceMode[PersistenceMode["Write"] = 1] = "Write";
    PersistenceMode[PersistenceMode["Update"] = 2] = "Update";
    PersistenceMode[PersistenceMode["Reset"] = 3] = "Reset";
})(PersistenceMode || (PersistenceMode = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/PersistenceMode.ts
// module id = 92
// module chunks = 3